import { createContext, useContext, useState, useEffect } from 'react';
import en from '../i18n/en.json';
import es from '../i18n/es.json';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('pillar-language');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('pillar-language', language); // eslint-disable-line react-hooks/exhaustive-deps
    document.documentElement.lang = language;
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'es' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const translations = { en, es };

export default LanguageContext;
